import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Application } from 'src/app/models/application.model';
import { Employee } from 'src/app/models/employee.model';
import { ApplicationService } from 'src/app/services/application_service.service';
import { TokenStorageService } from 'src/app/services/token_storage.service';
import { Location, DatePipe } from '@angular/common';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatNoDataRow } from '@angular/material/table';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: 'application',
    templateUrl: './application.component.html',
    styleUrls: ['./application.component.scss'],
    imports: [MatProgressBar, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatIconButton, MatIcon, MatTooltip, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatNoDataRow, DatePipe]
})
export class ApplicationComponent implements OnInit {
    employee!: Employee;
    applications: Application[] = [];
    applicationDataSource = new MatTableDataSource<Application>([]);
    applicationColumnHeaders: string[] = ['name', 'applicationStatus', 'dateSubmitted', 'action'];

    // default to submitted statuses
    selectedApplicationStatus = 'Submitted';
    loading = false;

    constructor(
        private router: Router,
        private storage: TokenStorageService,
        private applicationService: ApplicationService,
        private location: Location,
    ) {}

    ngOnInit(): void {
        this.employee = this.storage.getUser();
        if (this.employee.employeeRole === 'Admin' || this.employee.employeeRole === 'Underwriter') {
            this.getAllApplications();
        } else {
            this.router.navigate(['home']);
        }
    }

    getAllApplications(): void {
        this.loading = true;

        const queryParams = new Map();
        queryParams.set('applicationStatus', this.selectedApplicationStatus);

        this.applicationService.getAll([], queryParams).subscribe(x => {
            this.applications = x;
            this.loading = false;
            this.refreshApplicationTable();
        }, (_) => this.loading = false);
    }

    refreshApplicationTable(): void {
        this.applicationDataSource.data = this.applications;
    }

    reviewApplication(id: string): void {
        this.router.navigate(['application', id]);
    }
}
